/**
 * Global state manager for modals opened from alert items
 * This allows modals to persist even when the alert component unmounts
 */
const alertModalsState = {
  openModals: new Map(), // Map<alertId, { generationData, onClose }>
};

const notifyAlertModalStateChanged = () => {
  window.dispatchEvent(new CustomEvent("alertModalStateChanged"));
};

export const openAlertModal = (alertId, generationData, onClose) => {
  const nextOpenModals = new Map();
  nextOpenModals.set(alertId, { generationData, onClose });
  alertModalsState.openModals = nextOpenModals;
  notifyAlertModalStateChanged();
};

export const closeAlertModal = (alertId) => {
  alertModalsState.openModals.delete(alertId);
  notifyAlertModalStateChanged();
};

export const getOpenAlertModals = () => {
  return Array.from(alertModalsState.openModals.entries()).map(
    ([alertId, data]) => ({
      alertId,
      ...data,
    })
  );
};

export default alertModalsState;
